export const getAutocompleteStyles = (skipWidth = false) => ({
    '& .MuiInputLabel-root': {
      display: 'none',
    },
    '& .MuiOutlinedInput-root': {
        fontFamily:"Glegoo",
        borderRadius: 0,
        fontSize: "13px",
        ...(skipWidth ? {} : { width: '35vw' }),
    },
    '& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--neutral-600)', 
      },
    '& .MuiOutlinedInput-input': {
      padding: '10px',
    },
    "& .MuiInputBase-root.Mui-disabled": {
      "& > fieldset": {
        borderColor: 'var(--neutral-600)', 
      }
  }
  });

  export const  getAutocompleteoutlinewidthStyles = () => ({
    '& .MuiOutlinedInput-root': {
        width: '350px',
    },
  });
